var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"haveHeaderWrap"},[(_vm.xmFlag)?_c('XHeader',{ref:""}):[(_vm.hosttype)?_c('Header',{ref:"Header"}):_vm._e()],_c('div',{staticClass:"mainWrap",style:({ paddingTop: _vm.hosttype ? '2px' : '0' })},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }